/**
 * @generated SignedSource<<724b1caa3dbe4b38a5a66f96ce3f6919>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuInputRangeDimensions_itemSearch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch" | "SbSharedRefineMenuFilterTableSize_itemSearch" | "SbSharedRefineMenuInputRange_itemSearch" | "useMeasurementUnit_itemSearch">;
  readonly " $fragmentType": "SbSharedRefineMenuInputRangeDimensions_itemSearch";
};
export type SbSharedRefineMenuInputRangeDimensions_itemSearch$key = {
  readonly " $data"?: SbSharedRefineMenuInputRangeDimensions_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuInputRangeDimensions_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuInputRange_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMeasurementUnit_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDimensionUnitRadioSelect_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterTableSize_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "20c75bf58d043ff56b2a9b8b84e73997";

export default node;
